import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, PropsWithChildren } from "react";

export const PlayerFrame = styled(Box)({
  position: "relative",
  paddingTop: "56.25%",
  height: 0,
  overflow: "hidden",
  display: "flex",
  bgcolor: "rgba(255, 255, 255, 0.13)",
  borderRadius: 1,
});

export const PlayerBox = forwardRef(({ children }: PropsWithChildren, ref) => (
  <PlayerFrame ref={ref}>
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexFlow: "column",
        borderRadius: 1,
        bgcolor: "grey.800",
      }}
    >
      {children}
    </Box>
  </PlayerFrame>
));
